import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "../api/client";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [csrfToken, setCsrfToken] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    api.getSession()
      .then((session) => {
        setUser(session.user);
        setCsrfToken(session.csrfToken);
      })
      .finally(() => setChecking(false));
  }, []);

  const value = useMemo(() => ({
    user,
    csrfToken,
    checking,
    login: async (survivorId, password) => {
      const session = await api.login(survivorId, password);
      setUser(session.user);
      setCsrfToken(session.csrfToken);
      return session.user;
    },
    register: async (registration) => {
      const session = await api.register(registration, csrfToken);
      setUser(session.user);
      setCsrfToken(session.csrfToken);
      return session.user;
    },
    logout: async () => {
      await api.logout(csrfToken);
      setUser(null);
      setCsrfToken(null);
    },
  }), [user, csrfToken, checking]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
